query GetProvenExpertSettings($companyId: String!) {
  settings(companyId: $companyId) {
    company {
      provenExpertLink
      showProvenExpertOnLandingpage
    }
  }
}
